import _ from 'lodash';
import React from 'react';
import { Link as RRLink } from 'react-router-dom';

const createPath = (to) => {
  const path = _.get(to, 'pathname', '/');
  const search = _.get(to, 'search');

  return search && search !== '?'
    ? `${path}${search.charAt(0) === '?' ? search : `?${search}`}`
    : path;
};

const Link = ({ to, ...props }) => {
  const path = _.isObject(to) ? createPath(to) : to;
  const isAbsoluteRoute = /^(?:[a-z]+:)?\/\//i.test(path);
  const InnerLink = isAbsoluteRoute ? 'a' : RRLink;
  const toKeyName = isAbsoluteRoute ? 'href' : 'to';
  const currentProps = { ...props, [toKeyName]: path };

  return <InnerLink {...currentProps} />;
};

export default Link;
